module.exports = __webpack_public_path__ + "static/media/8.da6c0304.jpg";